export default "<label\n  class=\"ui-input-label form-label\"\n  for=\"{{ labelFor }}\"\n  ng-transclude>\n  {{ label | translate }}\n</label>";